export class CertPeriodicityEntity {
    id:number;
    certificateId:number;
    periodicityId:number;
    
    constructor() { }
}